// cookies 用户id
export const USER_ID_COOKIES_KEY = 'USER_ID'

// cookies 用户token
export const USER_TOKEN_COOKIES_KEY = 'USER_TOKEN'
// cookies 广告id
export const AD_ID_COOKIES_KEY = 'AD_ID'

// localStorage 用户登录信息
export const USER_IS_LOGIN_STORE_KEY = 'USER_IS_LOGIN'
// localStoreage 用户是否购买vip
export const USER_IS_VIP_STORE_KEY = 'USER_IS_VIP'

// 是否是投放用户
export const IS_TOUFANG_STORE_KEY = 'IS_TOUFANG'


export const ROUTER_TYPE = {
    ADX: 'reader',
    ADS: 'reader-s',
    TABOOLA: 'reader-t',
}